import { SearchOutlined } from "@ant-design/icons";
import { Input } from "antd";

interface SearchComponentProps {
  searchQuery: string;
  setSearchQuery: (query: string) => void;
  placeholder?: string;
  children?: React.ReactNode;
}

export const SearchComponent: React.FC<SearchComponentProps> = ({ 
  searchQuery, 
  setSearchQuery,
  placeholder = "input search text",
  children
}) => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        backgroundColor: "#5B5F881A",
        padding: "20px",
        borderRadius: "10px"
      }}>
      <Input
        placeholder={placeholder}
        onChange={(e) => setSearchQuery(e.target.value)}
        value={searchQuery}
        prefix={<SearchOutlined color="#667085" style={{ color: "#667085" }} />}
        style={{ 
          width: "400px",
          height: "44px",
          border: "1px",
          borderRadius: "8px",
          padding: "10px 14px"
        }}
      />
      {children}
    </div>
  );
};
